import {Box, Pagination} from '@mui/material';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {getCustomerCards} from '../actions';
import useFilters from '../utils/useFilters';
import CardsTable from './CustomTables/CardsTable';
import {Filters} from '.';

const CardsTab = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    customerCards,
    customersCardsPage,
    customersCardsTotalPages,
    cardsLoading,
  } = useSelector(s => s.cards);
  const {customerById} = useSelector(s => s.customers);
  const filters = useFilters(val => dispatch(getCustomerCards(id, val)));

  const handleAddCard = () => {
    navigate(`/customers/${id}/add_card`);
  };
  const goToCard = id => {
    navigate(`/card/${id}`);
  };

  const onPageChange = (e, value) => {
    dispatch(getCustomerCards(id, {page: value, ...filters.filters}));
  };

  return (
    <>
      <Box position="absolute" zIndex={1}>
        <Filters m="0 !important" withSearch {...filters} />
      </Box>
      <CardsTable
        loading={cardsLoading}
        cards={customerCards}
        onAdd={customerById && handleAddCard}
        onRowClick={goToCard}
        rowHref={id => `/card/${id}`}
      />
      {customersCardsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={customersCardsTotalPages}
            page={customersCardsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default CardsTab;
